/**
 * menuItem 子组件
 *
 * 目前为 head foot 组件使用，可扩展到其它组件上
 * 格式为统一的 html 代码：
<a href="" :class="current" :data-scp="scp">
	<i class="icon icon-xxx"></i>
    <span>XXXXX</span>
</a>
 * 可添加其它自定义事件
 * */
// 目前 head 用到
import back from './back.vue';              // 返回
import shoppingCart from './shoppingCar.vue';   // 购物车
import menuControl from './menuControl.vue';    // 菜单
import index from './goIndex.vue';          // 首页
import share from './share.vue';            // 分享
import jubao from './jubao.vue';            // 分享
import position from './position.vue';      // 选择城市
import currCity from './currCity.vue';      // 当前城市
import backIndex from './backIndex.vue';    // 返回首页
import avatar from './avatar.vue';          // 个人头像
import edit from './edit.vue';
import category from './category.vue';      // 分类

import unbind from './unbind.vue';          // 解绑
import usedCoupon from './usedCoupon.vue';    // 查看已使用/失效券
import search from './search.vue';    // 搜索

// 目前 foot 用到
import store from './store.vue';            // 逛商城
import citihui from './citihui.vue';        // 城市惠
import shiyixiu from './shiyixiu.vue';     // 试衣秀
import coupon from './coupon.vue';          // 优惠
import member from './member.vue';          // 我的
import shiyijian from './shiyijian.vue';    // 试衣间
import overseas from './overseas.vue';    // 全球购
import gouwu from './gouwu.vue';    // 购物
import shoucangjian from './shoucangjian.vue';//收藏间
import radar from './radar.vue';    // 试衣秀搜索
import message from './message.vue';    // 试衣秀消息
import add from './add.vue';    // 试衣秀发布
import fittingShowMember from './fittingShowMember.vue';    // 试衣秀我的
import discoverMember from './discoverMember.vue';          // 发现我的
import discover from './discover.vue';          // 发现首页
import discoverfill from './discoverfill.vue';          // 发现首页

import goodgoods    from './goodgoods.vue'; // 好物圈
import webcast      from './webcast.vue';   // 直播

export default {
	back
	, shoppingCart
	, menuControl
	, index
	, share
	, position
	, currCity
	, store
	, citihui
	, shiyixiu
	, coupon
	, member
	, shiyijian
	, overseas
	, gouwu
	, shoucangjian
	, radar
	, message
	, add
	, fittingShowMember
	, jubao
	, backIndex
	, unbind
	, usedCoupon
	, avatar
	, discoverMember
	, discover
	, discoverfill
	, category
	, edit
	,search
	, goodgoods
	, webcast
};